<mat-form-field appearance="outline" class="w-20 uppercase small" subscriptSizing="dynamic">
  <mat-select
    [disableRipple]="true"
    [hideSingleSelectionIndicator]="true"
    [value]="languageSelected()"
    (selectionChange)="changeLanguage($event)">
    @for (language of languages; track language) {
      <mat-option [value]="language.id">{{ language.id }}</mat-option>
    }
  </mat-select>
</mat-form-field>
